import React from 'react';

export const ArrowRight = ({ size = 24, color = "#007E47" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7629 12C19.7629 12.4142 19.4272 12.75 19.0129 12.75L4.98718 12.75C4.57297 12.75 4.23718 12.4142 4.23718 12C4.23718 11.5858 4.57297 11.25 4.98718 11.25L19.0129 11.25C19.4272 11.25 19.7629 11.5858 19.7629 12Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0589 18.9537C11.766 18.6608 11.766 18.1859 12.0589 17.893L18.4824 11.4695C18.7753 11.1766 19.2501 11.1766 19.543 11.4695C19.8359 11.7624 19.8359 12.2373 19.543 12.5302L13.1196 18.9537C12.8267 19.2466 12.3518 19.2466 12.0589 18.9537Z"
      fill={color}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0591 5.0462C12.352 4.75331 12.8269 4.75331 13.1198 5.0462L19.5433 11.4697C19.8362 11.7626 19.8362 12.2374 19.5433 12.5303C19.2504 12.8232 18.7755 12.8232 18.4826 12.5303L12.0591 6.10686C11.7663 5.81397 11.7663 5.33909 12.0591 5.0462Z"
      fill={color}
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/ArrowRight.icon.jsx